import type { TimeSeriesPointCustom } from '@/features/_shared/chart/lib/buildChartLineSeries';
import { findClosestPoint } from '@/features/_shared/chart/lib/findClosestPoint';
import { formatPriceValue } from '@/shared/lib/format/formatPriceValue';

import type { Point } from 'highcharts';
import type Highcharts from 'highcharts/highstock';

export const createTooltip = ({
  allChartSeries,
  hoveredPointXValue,
  createHeader,
  createBodyRow
}: {
  allChartSeries: Highcharts.Series[];
  hoveredPointXValue: string | number | undefined;
  createHeader: () => string;
  createBodyRow: (point: Point, custom: TimeSeriesPointCustom | undefined, value: string) => string;
}): string => {
  allChartSeries = allChartSeries.filter(series => !series.name.includes('Navigator'));

  const points: Highcharts.Point[] = allChartSeries
    .filter(series => series.visible && (series as { points: Highcharts.Point[] | null }).points)
    .map(series => findClosestPoint(series.points, Number(hoveredPointXValue)))
    .filter(x => !!x);
  const header = createHeader();

  const body = points
    .map(point => {
      // @ts-expect-error: highcharts rules.
      const custom = point.custom as TimeSeriesPointCustom | undefined;
      let value = '';
      if (point.y !== undefined && !Number.isNaN(point.y)) {
        value = formatPriceValue(custom?.decimalPlaces ?? 2, point.y);
      }
      return createBodyRow(point, custom, value);
    })
    .join('');
  return header + body;
};
